import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
  ChangeDetectionStrategy
} from '@angular/core';
import { AnimationService } from 'src/app/services/animation/animation.service';

@Component({
  selector: 'app-what-we-do',
  templateUrl: './what-we-do.component.html',
  styleUrls: ['./what-we-do.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WhatWeDoComponent implements OnInit {
  @ViewChildren('textContent') textContent!: QueryList<ElementRef>;
  @ViewChildren('leftReveal') leftReveal!: QueryList<ElementRef>;
  @ViewChildren('rightReveal') rightReveal!: QueryList<ElementRef>;

  constructor(private animate: AnimationService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const elements = this.textContent.toArray().map((el) => el.nativeElement);
    const rightElems = this.rightReveal.toArray().map((el) => el.nativeElement);
    const leftElems = this.leftReveal.toArray().map((el) => el.nativeElement);
    if (elements) {
      this.animate.fadeInElementsImmediate(elements, 0.05);
      console.log('1st');
    }
    this.animate.revelText(leftElems);
    this.animate.revelTextRight(rightElems);
  }

  isShown: boolean = false;

  readText() {
    this.isShown = !this.isShown;
  }
}
